import { render, staticRenderFns } from "./BrPages.vue?vue&type=template&id=0714008a&"
import script from "./BrPages.vue?vue&type=script&lang=js&"
export * from "./BrPages.vue?vue&type=script&lang=js&"
import style0 from "./BrPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports